import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaBancosResumen', NominasNominaBancosResumen)

function NominasNominaBancosResumen(NominasNomina, NominasNominaConceptos, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaBancos, $q, $filter) {
  this.get = get

  function get(idEmpresa, idNomina) {
    return $q.all({
      nomina: NominasNomina.get(idEmpresa, idNomina),
      nominaConceptos: NominasNominaConceptos.get(idEmpresa, idNomina),
      nominaEmpleados: NominasNominaEmpleados.get(idEmpresa, idNomina),
      nominaSuministro: NominasNominaSuministro.get(idEmpresa, idNomina),
      nominaBancos: NominasNominaBancos.get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      let grupos = {},
        data = [],
        capitalize = $filter('capitalize'),
        orderBy = $filter('orderBy')

      $resolve.nominaEmpleados.forEach(function (empleado, index) {
        let suministro = $resolve.nominaSuministro[index],
          banco = $resolve.nominaBancos[index].Bancos.find(function (banco) {
            return banco.ID_Moneda === $resolve.nomina.ID_Moneda
              && banco.ID_Banco !== '000'
          }) || {Banco: 'No especificado'}

        let row = {
          ID_Empresa: empleado.ID_Empresa,
          ID_Empleado: empleado.ID_Empleado,
          Empleado: capitalize(empleado.Empleado, true),
          Empresa: empleado.Empresa,
          Total_Pagar: suministro.Total,
          Banco: banco.Banco,
          Banco_ID: banco.ID_Banco,
          Banco_Cuenta: banco.Cuenta,
          Banco_CLABE: banco.CLABE,
          Banco_Notas: banco.Notas,
        }

        $resolve.nominaConceptos.forEach(function (concepto) {
          let deduccion = suministro.Deducciones[concepto.ID_Concepto]
          row.Total_Pagar -= angular.isNumber(deduccion.editado)
            ? deduccion.editado
            : deduccion.calculado
        })

        let grupo = row.Banco

        if (!grupos[grupo]) {
          grupos[grupo] = {
            label: grupo,
            items: [],
            data: {
              Total_Pagar: 0,
            },
          }
          data.push(grupos[grupo])
        }
        grupos[grupo].items.push(row)
        grupos[grupo].data.Total_Pagar = parseFloat((grupos[grupo].data.Total_Pagar + row.Total_Pagar).toFixed(2))
      })

      return orderBy(data, '-data.Total_Pagar')
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Bancos/Resumen.js